<script setup lang="ts">
import { AppStars } from '@libs/ui';

import type { ActivityProductCardContent } from '../../../models';

interface ActivityProductCardContentProps {
  productCardContent: ActivityProductCardContent;
}

const props = defineProps<ActivityProductCardContentProps>();

interface ActivityProductCardContentEmits {
  (eventName: 'show-details'): void;
}

const emit = defineEmits<ActivityProductCardContentEmits>();
</script>

<template>
  <button class="activity-product-card-content" @click="emit('show-details')">
    <div class="details">
      <div class="upper-section">
        <button class="name" @click="emit('show-details')">
          {{ props.productCardContent.header }}
        </button>
        <div class="location">{{ props.productCardContent.subheader }}</div>
        <AppStars :amount="props.productCardContent.rating.stars" size="18" />
      </div>

      <div class="middle-section">
        <div
          v-for="element in props.productCardContent.cardDetails"
          :key="element.label + element.description"
          class="row"
        >
          <div class="label">{{ element.label }}:</div>
          <div class="description">
            {{ element.description }}
          </div>
        </div>
      </div>
    </div>
  </button>
</template>

<style scoped lang="scss">
.activity-product-card-content {
  all: unset;
  height: 100%;

  @include for-less-or-equal-than-599-px {
    grid-template-rows: auto auto auto;
    grid-template-columns: auto;
  }

  .details {
    width: 100%;
    height: 100%;
    padding: var(--spacing-16) var(--spacing-12);

    display: flex;
    flex-flow: column;
    flex: 1;

    .upper-section {
      padding-bottom: var(--spacing-16);

      .name {
        all: unset;
        padding: 0;
        @include font-label-xl-bold;
        margin-bottom: var(--spacing-4);

        @include on-hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }

      .location {
        @include font-label-s-light;
        margin-bottom: var(--spacing-4);
      }
    }

    .middle-section {
      .row {
        display: flex;
        gap: var(--spacing-4);
        margin-bottom: var(--spacing-8);

        .label {
          @include font-label-s-bold;
          white-space: nowrap;
        }
        .description {
          @include font-label-s-light;
        }
      }
    }
  }

  .price {
    align-self: center;
  }
}
</style>
